import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route-level permission guard (docs/conventions.md §2). Wrap a page element
 * in App.js: <RequirePermission permission="engagements:edit"><Page/></RequirePermission>.
 * `permission` may be a string or an array (any one grants access).
 * hasPermission() already bypasses for the super_admin rescue account.
 * Display-only — the real enforcement is the backend middleware.
 */
const RequirePermission = ({ permission, children }) => {
  const { hasPermission } = useAuth();
  const required = Array.isArray(permission) ? permission : [permission];

  if (!required.some((p) => hasPermission(p))) {
    return (
      <div className="p-8 max-w-xl mx-auto">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <h2 className="text-lg font-semibold text-red-800">Access denied</h2>
          <p className="text-sm text-red-600 mt-1">
            You do not have permission to view this page.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default RequirePermission;
